import React, { ChangeEvent } from 'react';
import { Checkbox } from '..';

interface PropType {
    name: string;
    value?: boolean | null | undefined;
    placeholder?: string;
    hint?: string;
    onChangeHandler: (value: boolean, name: string) => void;
    label?: string;
}

const InputCheckbox = (props: PropType) => {
    return (
        <Checkbox
            checked={!!props.value}
            label={props.label}
            onChange={(e: ChangeEvent<any>) => {
                props.onChangeHandler(e.currentTarget.checked, props.name);
            }}
            hint={props.hint}
        />
    );
};

export default InputCheckbox;



// WEBPACK FOOTER //
// ./src/components/Form/InputCheckbox.tsx